import './src/styles/global.css';
import { GatsbyBrowser } from 'gatsby';

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = (route) => {
  if (route.location?.pathname !== '/') {
    const calendlyBadge = document.querySelector('.calendly-badge-widget');

    if (calendlyBadge) {
      calendlyBadge.remove();
    }
  }
};
